<template>
    <div
            v-if="show"
            class="hmsurvey fixed bottom-0 sm:right-0 sm:top-0 border bg-white shadow-sm duration-200 overflow-hidden"
            :style="style"
    >
        <h-m-survey-header-button :state="headerButtonState" @click="headerButtonClick" class="mt-2 transform rotate-90 sm:rotate-0 absolute duration-200 z-10" :style="headerButtonStyle"></h-m-survey-header-button>
        <button @click="toggleOpen" class="absolute overflow-hidden transform sm:rotate-90 origin-right w-32 mt-2 text-right font-bold text-lg text-ultramarine duration-200 z-10" :style="{right: openButtonRight, top: openButtonTop}">Feedback Form</button>

        <div class="text-left py-4 pl-6 pr-6 sm:pr-12 h-full duration-200" :style="contentStyle" :class="{'opacity-0': !this.open}">

            <div v-if="status === 'ready'" class="flex flex-col justify-between h-full">
                <div>
                    <h2 class="text-xl font-bold" v-text="_label('feedback_form')"></h2>
                </div>
                <div>
                    <p class="text-center" v-text="_label('tell_us_how_me_might_improve')"></p>
                </div>
                <div class="text-center">
                    <button class="btn border border-ultramarine btn rounded-full text-lg px-8 py-1 font-semibold" @click="startSurvey" v-text="_label('start_now')"></button>
                </div>
            </div>

            <div v-if="status === 'questions'" class="h-full">
                <h-m-survey-question
                        v-for="question, i in questions"
                        v-if="i === questionIterator"
                        :key="i"
                        :question="question"
                        :count="questions.length"
                        :last="isLastQuestion"
                        v-model="answers[i]"
                        @next="next"
                        @submit="submit"
                ></h-m-survey-question>
            </div>

            <div v-if="status === 'sending'" class="h-full flex justify-center items-center">
                <loading-animation></loading-animation>
            </div>

            <div v-if="status === 'finished'" class="h-full">
                <h2 class="text-3xl font-bold mb-2"><span v-text="_label('thank_you')"></span>!</h2>
                <p v-text="_label('hive_mind_team')"></p>

                <div class="mt-8">
                    <p class="mb-2 text-lg"><a href="/blog" v-text="_label('see_the_latest_blog_posts')"></a></p>
                    <p><a href="/blog"><span class="icon-arrow-right text-xl"></span></a></p>
                </div>

                <div class="mt-8">
                    <p class="mb-2 text-lg"><a href="/tools" v-text="_label('check_out_the_toolkit')"></a></p>
                    <p><a href="/tools"><span class="icon-arrow-right text-xl"></span></a></p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    let token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }

    import HMSurveyHeaderButton from './HMSurveyHeaderButton'
    import HMSurveyQuestion from './HMSurveyQuestion'
    export default {
        name: "HMSurvey",
        components: {HMSurveyHeaderButton, HMSurveyQuestion},
        props: {
            cookieName: {
                default: 'survey-1'
            },
            breakpoint: {
                default: 640,
            }
        },
        data() {
            return {
                show: false,
                open: false,
                status: 'ready',
                questionIterator: 0,
                answers: {},
                questions: [
                    {
                        no: 1,
                        type: 'options',
                        title: 'Which best describes you?',
                        options: [
                            'Activist',
                            'Trainer',
                            'NGO representant',
                            'Other',
                        ],
                    },
                    {
                        no: 2,
                        type: 'options',
                        title: 'What is the main purpose of your visit today?',
                        options: [
                            'Take self course',
                            'Participate in Online Training',
                            'Read blog article',
                            'Looking for tools',

                        ],
                    },
                    {
                        no: 3,
                        type: 'options',
                        title: 'Do you trust the information on Hive Mind?',
                        options: [
                            'yes',
                            'no',
                            'i_dont_know',
                        ],
                    },
                    {
                        no: 4,
                        type: 'open',
                        title: 'How can we improve?',
                    }
                ],
                isMobile: true,
            };
        },
        computed: {
            style() {
                return {
                    width: this.width,
                    height: this.height,
                    'margin-left': this.marginLeft,
                };
            },
            width() {
                if (this.open) {
                    return 'calc(20rem + 2px)';
                }
                return this.isMobile ?
                    '12rem' :
                    '3rem';
            },
            height() {
                if (this.open) {
                    return '25rem';
                }
                return this.isMobile ?
                    '3rem' :
                    '12rem';
            },
            marginLeft() {
                if (this.open) {
                    return this.isMobile ?
                        'calc(-10rem - 1px)' :
                        '0';
                }

                return this.isMobile ?
                    '-6rem' :
                    '0';
            },
            headerButtonState() {
                if (this.open) {
                    if (this.status !== 'ready') {
                        return 'close'
                    }
                    return 'arrow-right';
                }
                return 'arrow-left';
            },
            headerButtonStyle() {
                return {
                    top: this.headerButtonTop,
                    right: '0.8rem',
                };
            },
            headerButtonTop() {
                return this.open ?
                    '0.5rem' :
                    '0';
            },
            openButtonRight() {
                if (this.open) {
                    return this.isMobile ?
                        '3rem' :
                        '-1rem';
                }
                return this.isMobile ?
                    '3rem' :
                    '1.5rem';
            },
            openButtonTop() {
                if (this.open) {
                    return this.isMobile ?
                        '-2rem' :
                        '9.5rem';
                }

                return this.isMobile ?
                    '0' :
                    '9.5rem';
            },
            isLastQuestion() {
                return (this.questionIterator === (this.questions.length - 1));
            },
            submitParams() {
                const params = [];

                for (const [key, value] of Object.entries(this.answers)) {
                    params.push({
                        no: key,
                        answer: value
                    });
                }

                return params;
            },
            contentStyle() {
                return {
                    width: 'calc(20rem + 2px)',
                    height: '25rem',
                };
            },
        },
        methods: {
            headerButtonClick() {
                if (this.open) {
                    this.open = false;
                } else {
                    this.open = true;
                }
            },
            toggleOpen() {
                this.open = !this.open;
            },
            startSurvey() {
                this.open = true;
                this.status = 'questions';
            },
            next() {
                if (this.isLastQuestion) {
                    return;
                }

                this.questionIterator++;
            },
            submit() {
                if (!this.isLastQuestion) {
                    return;
                }

                this.status = 'sending';
                axios.post('/survey', {
                    survey: this.submitParams
                }).then(() => {
                    this.$cookies.set(this.cookieName, true);
                })
                    .catch((error) => {
                        // handle error
                        console.log(error);
                    })
                    .finally(() => {
                        this.status = 'finished';
                    });

            },
            onResize() {
                this.isMobile = (window.innerWidth < this.breakpoint);
            },
            _label(key) {
                return this.$options.filters['lang']('copy.' + key);
            }
        },
        mounted() {
            if (!this.$cookies.get(this.cookieName)) {
                this.show = true;
            }
            window.addEventListener('resize', this.onResize);
            this.onResize();
        },
        watch: {
            open(val) {
                if (!val) {
                    if (this.$cookies.get(this.cookieName)) {
                        this.show = false;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>